import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Config } from '../config'
import type { Plugin } from '../plugin'

/**
 * Updates the current list after entity creation.
 *
 * The strategy is controlled by @see {@link Config.creationStrategy}.
 */
export const updateListOnCreation = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.collection.plugins.dataOperationPlugin.feature.actions.create.success
      .observe()
      .pipe(
        rxjs.map(action => {
          if (
            plugin.config.creationStrategy === 'optimistic' &&
            action.data.response &&
            action.data.response.length > 0
          ) {
            return feature.actions.insert.from(action).create({
              ids: action.data.response.map(entity =>
                plugin.collection.identify(entity),
              ),
            })
          }
          return feature.actions.load.from(action).create()
        }),
      ),
)
